import { Pipe, PipeTransform } from '@angular/core';
import { LicenceDataModel } from 'src/app/models/lic-list.model';
import { BeatsService } from 'src/app/services/beats-service/beats.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';

@Pipe({
  name: 'getLicenceTitle'
})
export class GetLicenceTitlePipe implements PipeTransform {
  licenceData:any;
  licenceFileData:any;
  
  constructor(private beatService: BeatsService,
    private browserService: BrowserStorageService){}
  transform(licenceId: any, actionType: string, licenceArray: any = '', pewViewUrl: string = ''): any {
    let titleName: any = '';
    if (this.browserService.getLicData().length > 0) {
      this.licenceData = this.browserService.getLicData();
      titleName = this.getTitleName(licenceId, actionType, licenceArray, pewViewUrl);
    } else {
      this.beatService.getLicence().subscribe((res: Array<LicenceDataModel>) => {
        this.licenceData = res;
        titleName = this.getTitleName(licenceId, actionType, licenceArray, pewViewUrl);
     });
    }
    return titleName;
  }

  getTitleName(licenceId: any, actionType: string, licenceArray: any, pewViewUrl: any): string {
    let titleName = "";
    let foundData =  this.licenceData.find((item:any) => item._id === this.getLicId(licenceId));
    if (foundData) {
      if (actionType === 'title') {
        titleName =  foundData?.title;
      } else if (actionType === 'slug') {
        titleName =  foundData?.slug;
      } else {
        if (licenceArray && licenceArray.length > 0 )  {
          licenceArray.map( (item:any) => {
            let slug =  this.getSlugArray(item?.file);
            let beatSerialNumber = this.getBeatSerialNumber(pewViewUrl);
            if (foundData?.slug === slug && item?.file.includes(beatSerialNumber)) {
              titleName = item?.file;
            }
          });
        }
      }
    }
    return titleName;
  }

  getSlugArray(urlType: any) {
    if (urlType) {
      let splitUrl = urlType.split('/');
      let beatNameWithOrderId =  (splitUrl[splitUrl.length - 1]).split('.')[0];
      let getSlug = beatNameWithOrderId.split('-');
      let finalSlugValue = getSlug[getSlug.length - 1];
      return finalSlugValue;
    }
     return '';
  }

  getBeatSerialNumber(preViewUrl: any ) {
    if (preViewUrl) {
      let splitUrl = preViewUrl.split('/');
      let beatNameWithOrderId =  (splitUrl[splitUrl.length - 2]).split('-');
      let finalBeatId = beatNameWithOrderId[beatNameWithOrderId.length - 1];
      return finalBeatId;
    }
    return  '';
  }

   getLicId(licence: any) {
    if (licence) {
      return typeof(licence)  === "string"  ? licence : licence._id
    }
    return 0;
  }
  
}
